import React from 'react'

import { APIURL } from '../constants'
import services from '../components/services'
import DefaultLayout from '../components/layouts/DefaultLayout'
import LegalDisplay from '../components/home/legal'

const Tos = (props) => <LegalDisplay {...props} />

Tos.Layout = DefaultLayout

export async function getServerSideProps(ctx) {
  const { host } = ctx.req.headers
  const res = await services.get_v2(APIURL.API_LEGAL('tos'), {}, host)
  if (res.statusCode !== 200) {
    return {
      notFound: true
    }
  }
  return {
    props: {
      title: 'Terms of Service',
      content: res.response
    }
  }
}

export default Tos
